var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfographics1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.136,
    height: 214.117,
    viewBox: "0 0 51.136 214.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f048cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00096"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4982d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285caa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0.357,
    cy: 0.294,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 0.714, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5998f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285caa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0.357,
    cy: 0.294,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 0.714, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4fd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00096"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 3.058, -2.324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.037.322a1.9,1.9,0,0,1,2.809.909c15.35,31.879,22.6,70.906,23.7,84.811A2.364,2.364,0,0,1,25.693,88.7a1.7,1.7,0,0,1-.2.011A2.231,2.231,0,0,1,23.451,86.5C22.373,72.938,15.289,34.841.272,3.654A2.7,2.7,0,0,1,1.037.322Z",
    transform: "translate(14.643 20.433)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15.163C0,6.789,5.851,0,13.068,0S26.136,6.789,26.136,15.163c0,7.12-4.229,13.09-9.931,14.721A226.584,226.584,0,0,1,9.877,85.05,2.131,2.131,0,0,1,7.9,86.8a1.8,1.8,0,0,1-.553-.088,2.455,2.455,0,0,1-1.432-2.94,221.171,221.171,0,0,0,6.182-53.49C5.331,29.7,0,23.157,0,15.163Z",
    transform: "translate(26.67 103.604)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.675,
    cy: 3.675,
    rx: 3.675,
    ry: 3.675,
    transform: "translate(49.439 97.478)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.675,
    cy: 3.675,
    rx: 3.675,
    ry: 3.675,
    transform: "translate(26.67 0)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.675,
    cy: 3.675,
    rx: 3.675,
    ry: 3.675,
    transform: "translate(48.634 196.189)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.407,
    cy: 14.407,
    rx: 14.407,
    ry: 14.407,
    transform: "translate(0 6.27)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.407,
    cy: 14.407,
    rx: 14.407,
    ry: 14.407,
    transform: "translate(25.46 104.616)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.407,
    cy: 14.407,
    rx: 14.407,
    ry: 14.407,
    transform: "translate(17.597 184.393)",
    fill: "url(#d)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographics1);
export default __webpack_public_path__ + "static/media/Infographics1.5d90d1ab15833b060c9db4d7f614b8d4.svg";
export { ForwardRef as ReactComponent };